export const GLOBAL_DICTIONARY = {
	other: 'Otro'
};
